"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readFragment = exports.graphql = void 0;
const gql_tada_1 = require("gql.tada");
exports.graphql = (0, gql_tada_1.initGraphQLTada)();
var gql_tada_2 = require("gql.tada");
Object.defineProperty(exports, "readFragment", { enumerable: true, get: function () { return gql_tada_2.readFragment; } });
